systemSettingsSoundsButton = {};

systemSettingsSoundsButton.create = function() {
    var button = new PIXI.Container();
    
    InputHelpers.addGenerics(button);
    InputHelpers.addCanSpinFlag(button);
	
    button.canEnable = function() {
    	return true;
    };
    
    button.onPressedCallback = function() {
        
    };

    return button;
};

systemSettingsSoundsButton.initialise = function(json, object) {
	object.soundName = json.soundName || "";
};
systemSettingsSoundsButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("systemSettingsSoundsButton", systemSettingsSoundsButton.create, systemSettingsSoundsButton.initialise, systemSettingsSoundsButton.getFilesRequired);